const utils = Object.assign({}, window.dnn.utility); //make copy, in case of accidental change.
export default utils;